<template>
  <div :style="{ padding: ' 10px', background: 'white' }">
    <div class="tablelist" v-loading.fullscreen.lock="loading">
      <div class="back">
        <el-page-header @back="goBack" title="返回"> </el-page-header>
      </div>
      <div v-show="showempty">该类型暂无学生报名表</div>
      <el-alert
        v-show="btndisabled"
        :closable="false"
        :title="'当前未处于申请时间内，申请时间为' + startdate + '至' + enddate"
        type="error"
      >
      </el-alert>

      <h3 v-html="getText(basicData.tablename)"></h3>

      <fm-generate-form
        v-if="show"
        :data="jsonData"
        :remote="remoteFuncs"
        :value="editData"
        :remote-option="dynamicData"
        ref="generateForm"
      >
      </fm-generate-form>
      <div
        class="tableBox"
        v-for="(subtableData, subtableDataindex) in subtableData"
        :key="subtableData.key"
      >
        <el-divider content-position="left">{{ subtableData.name }}</el-divider>
        <el-table
          v-if="subtableData.subtable"
          :data="subtableData.subtable[0].keyvalue"
          style="width: 100%"
          ref="appTable"
          border
          empty-text="数据"
          max-height="600"
        >
          <el-table-column
            v-for="(tablelist, dd) in subtableData.tableTitle"
            :label="tablelist.label"
            :prop="tablelist.value"
            :key="tablelist.value"
          >
            <!-- 表头和表数据有相同唯一标识 v-model="row[tablelist.value]"  取到当前行的列字段tablelist.value与输入框进行双向绑定 -->
            <template slot-scope="scope">
              <el-input
                v-model="scope.row[scope.column.property]"
                placeholder="请输入内容"
              >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="showmould">
        <el-button
          style="margin: 30px auto 0px"
          type="primary"
          @click="downloadRequest()"
          size="small"
          >模板下载</el-button
        >
        <span style="color: red; margin-left: 5px"
          >请点击下载模板，根据模板填写或完善相关信息并上传</span
        >
      </div>
      <div class="footerBtn" v-if="show">
        <div v-if="Printing != '1'">
          <el-button
            v-if="showsub == false"
            :style="{ width: '200px' }"
            type="primary"
            @click="submit"
            :disabled="btndisabled"
            >{{ tableID == "" ? "提 交" : "重新提交" }}</el-button
          >
          <div
            v-if="showsub"
            style="margin-left: 40%; width: 200px; color: red; font-size: 28px"
          >
            {{ tableID == "" ? "不在申请时间内" : "申请时间已截止" }}
          </div>
        </div>
        <el-button
          v-if="Printing == '1'"
          :style="{ width: '200px' }"
          type="primary"
          @click="PrintingZKZ"
          :disabled="btndisabled"
          >打印准考证</el-button
        >
      </div>
    </div>
  </div>
</template>
<script src="https://unpkg.com/form-making/public/lib/ace/ace.js"></script>

<script>
export default {
  data() {
    return {
      Printing: "",
      showsub: false,
      showmould: false,
      subtableData: [],
      jsonData: {},
      basicData: [],
      show: false,
      subtableshow: false,
      remoteFuncs: {
        funcGetToken(resolve) {
          // 一寸照片 imgupload_1607478171657
          // resolve(token)
        },
      },
      editData: {},
      dynamicData: {},
      formID: "",
      tableID: "",
      loading: false,
      showempty: false,
      usersubtable: [],
      submitloading: false,
      btndisabled: false,
      startdate: "",
      enddate: "",
    };
  },
  methods: {
    PrintingZKZ() {
      this.uploadMoudleLoading = true;
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Diyform/ExprotWord`,
        responseType: "blob",
        params: {
          type: this.$store.state.QStype,
          formid: this.$store.state.enrollFormId,
          tableid: this.tableID,
          idcard: this.$store.state.idcard,
          
        },
      })
        .then((res) => {
          this.uploadMoudleLoading = false;
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          let name = "准考证.pdf";

          downloadElement.download = name; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((_) => {});
    },
    getText(val) {
      if (this.$store.state.QStype == "3") {
        if(val != undefined){
        return val.replace("APPLICATION", "<br>APPLICATION");
        }
      }
      return val;
    },
    downloadRequest(id) {
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Diyform/ExprotMouldFile?formid=${this.$store.state.enrollFormId}`,
        responseType: "blob",
      }).then((res) => {
        const content = res;
        const blob = new Blob([res.data], {
          type: "application/zip",
        });
        let fileName = "附件.zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    // 获取当前报名表
    getFormBycurrentVer() {
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Diyform/getFormJson?id=${this.$store.state.enrollFormId}`,
      })
        .then((res) => {
          console.log(res);
          // 显示 未处于报名时间内
          this.showempty = true;
          for (var i in res.data.response) {
            if (res.data.response[i].currentVer == 1) {
              // 有推送中的报名表  不显示提示
              this.showempty = false;
              let currentVerdata = res.data.response[i];
              this.formID = currentVerdata.id;
              let list = JSON.parse(currentVerdata.formjson);
              let config = JSON.parse(currentVerdata.formconfig);
              //let subtable = JSON.parse(currentVerdata.nodeconfig);
              let data = [];
              this.basicData = currentVerdata;
              this.Printing = currentVerdata.Printing;
              data.push({ list: list, config: config });
              // 表单数据
              this.jsonData = data[0];
              this.loading = false;
              if (
                currentVerdata.nodeconfig != "" &&
                currentVerdata.nodeconfig != undefined
              ) {
                this.showmould = true;
              }
              // 控制表单控件在数据接收完成后出现
              this.show = true;

              // 通过从表的key获取从表框数据
              // for (var i in subtable) {
              //   this.getSubtable(subtable[i].key);
              // }

              // 判断是否在提交时间内
              this.isPushDate(
                res.data.response[i].statime,
                res.data.response[i].endtime
              );
            }
          }
          this.loading = false;
        })
        .catch((_) => {});
    },
    // 获取从表
    getSubtable(key) {
      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/Diyform/getListInfo?keyid=${key}`,
      })
        .then((res) => {
          //  接收表格数据
          // 动态创建数据对象
          let inputname = [];
          let keyvalue = [];
          let subtable = [];
          // 判断是否获取到已经填写过的子表单数据
          if (this.usersubtable.length != 0) {
            for (let i in this.usersubtable) {
              // 创建的这个子表单拥有已经填写过的数据
              if (this.usersubtable[i].key == key) {
                subtable.push({
                  key: this.usersubtable[i].key,
                  keyvalue: this.usersubtable[i].data,
                });
              }
            }
          } else {
            // 没有获取到已经填写过的子表单数据
            for (let m in res.data.response.tableTitle) {
              let name = res.data.response.tableTitle[m].value;
              inputname.push(name);
            }
            for (let i = 0; i < 3; i++) {
              let inputlist = {};
              for (let a in inputname) {
                inputlist[inputname[a]] = "";
              }
              keyvalue[i] = inputlist;
            }
            subtable.push({
              key: key,
              keyvalue: keyvalue,
            });
          }
          this.subtableData.push({
            key: key,
            name: res.data.response.data[0].name,
            tableTitle: res.data.response.tableTitle,
            subtable: subtable,
          });
          this.loading = true;
        })
        .catch((_) => {});
    },
    goBack() {
      this.$router.push("/index");
    },
    // 获取已填数据
    getsubmitData() {
      this.loading = true;
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Diyform/getApplyInfo`,
        params: {
          type: this.$store.state.QStype,
          formid: this.$store.state.enrollFormId,
          userid: this.$store.state.userInfo.id,
          idcard: this.$store.state.idcard,
        },
      })
        .then((res) => {
          // console.log(res);
          // 记录id
          if (res.data.response.data && res.data.response.data.length != 0) {
            console.log(res.data.response.data.length);

            this.tableID = res.data.response.data[0].id;
            // inputlist表单数据  usersubtable从表数据
            let inputlist = {};
            inputlist = JSON.parse(res.data.response.data[0].listjson);
            this.usersubtable = JSON.parse(res.data.response.data[0].nodejson);
            this.$nextTick(() => {
              // 把已填写过的表单数据填到对应的框里
              this.editData = inputlist[0];
              this.$forceUpdate();
            });
            this.getFormBycurrentVer();
          } else if (
            res.data.msg == "error" ||
            !res.data.response.data ||
            res.data.response.data.length == 0
          ) {
            this.getFormBycurrentVer();
          }else{
            this.$message({
              message: "未查询到数据",
              type: "error",
              duration: 3000,
            });
          }
        })
        .catch((_) => {});
    },
    // 数据提交
    submit() {
      this.submitloading = true;
      let listData = [];
      let nodeconfig = [];
      let params = {};
      this.$refs.generateForm
        .getData()
        .then((data) => {
          console.log(data);
          listData.push(data);
          for (var i in this.subtableData) {
            nodeconfig.push({
              key: this.subtableData[i].key,
              data: this.subtableData[i].subtable[0].keyvalue,
            });
          }
          nodeconfig = JSON.stringify(nodeconfig);
          listData = JSON.stringify(listData);
          //  http://10.168.1.113:5000
          // /RegistrationMagt
          if (this.tableID) {
            params = {
              list: listData,
              nodeconfig: nodeconfig,
              id: this.formID,
              userid: this.$store.state.userInfo.id,
              username: this.$store.state.userInfo.name,
              tableid: this.tableID,
            };
          } else {
            params = {
              list: listData,
              nodeconfig: nodeconfig,
              id: this.formID,
              userid: this.$store.state.userInfo.id,
              username: this.$store.state.userInfo.name,
            };
          }
          this.$http({
            method: "post",
            url: `/RegistrationMagt/api/Diyform/SaveFormData`,
            data: params,
          })
            .then((res) => {
              console.log(res);
              this.submitloading = true;

              this.$allMethods.returnSuccess(res.data.msg, "提交");
              this.$allMethods.returnRrror(res.data.msg, res.data.response);
              this.goBack();
            })
            .catch((_) => {});
        })
        .catch((e) => {});
    },
    // 获取当前时间 与问卷时间比较 判断是否在提交时间内
    isPushDate(start, end) {
      let startdate = new Date(start.replace("T", " "));
      let enddate = new Date(end.replace("T", " "));

      let nowdate = new Date();
      console.log(nowdate);
      console.log(enddate);

      if (nowdate < startdate || nowdate > enddate) {
        this.btndisabled = true;
        this.showsub = true;
        this.startdate = start.replace("T", " ");
        this.enddate = end.replace("T", " ");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getsubmitData();
    });
  },
};
</script>
<style scoped>
.tablelist {
  padding: 20px 50px;
  width: 1000px;
  margin: 30px auto 0px;
  text-align: left;
  background: #2d76f908;
  border: 1px solid #f1f1f1;
  /* overflow: auto; */
}
.tablelist h3 {
  text-align: center;
  margin: 50px 0px 15px;
}
.tablelist p {
  text-align: center;
  margin: 10px 0px 50px;
  color: #afadad;
  font-size: 14px;
}
.footerBtn {
  text-align: center;
  margin: 30px 0px;
}
.back {
  margin: 40px 0px;
}
</style>